export interface FaqQuestion {
  question: string;
  answer: string;
  selected: boolean;
}

export interface Faq {
  category: string;
  questions: FaqQuestion[];
  selected: boolean;
}

export const mockedFaqs: Faq[] = [
  {
    category: 'Contatti e Supporto',
    questions: [
      {
        question:
          'Cosa posso fare se non trovo la risposta che cerco in queste FAQ?',
        answer:
          'Invia un’e-mail al nostro team dalla sezione FAQ>contattaci oppure direttamente all’account assistenza.psicogenius@gmail.com e otterrai una risposta nel più breve tempo possibile',
        selected: false,
      },
    ],
    selected: false,
  },
  {
    category: 'Abbonamento',
    questions: [
      {
        question: 'Come posso abbonarmi?',
        answer: `• Vai alla pagina https://app.psicogenius.it/
• Clicca su Iscriviti con Google
• Visiona e accetta i Termini di servizio 
• Completa con il pagamento dell’Abbonamento mensile
• Inizia il tuo lavoro!`,
        selected: false,
      },
      {
        question:
          'Dove posso visualizzare le informazioni relative al mio abbonamento?',
        answer:
          'Accedi alla tua area personale e clicca su “gestisci abbonamento” per visualizzare stato del tuo abbonamento, data del prossimo rinnovo e dati fiscali.',
        selected: false,
      },
      {
        question: 'Come disdico l’abbonamento?',
        answer: `Per disdire l’abbonamento accedi alla tua area riservata e seleziona la voce Gestisci abbonamento.
Potrai disdire il tuo abbonamento entro e non oltre 10 giorni dalla data del rinnovo successivo.`,
        selected: false,
      },
      {
        question: 'E’ possibile accedere al software da dispositivi mobili?',
        answer: `Sì, il software è accessibile tramite browser da qualsiasi dispositivo, inclusi smartphone e tablet, rendendo facile la gestione delle fatture ovunque ti trovi.`,
        selected: false,
      },
    ],
    selected: false,
  },
  {
    category: 'Privacy',
    questions: [
      {
        question: 'È sicuro gestire i dati dei pazienti tramite il software?',
        answer:
          'Sì, il software è progettato con elevati standard di sicurezza per proteggere i dati sensibili dei pazienti, garantendo la conformità alle normative sulla privacy.',
        selected: false,
      },
      {
        question: 'I dati restano a Psicogenius?',
        answer:
          'No, PSICOGENIUS non è proprietario né titolare dei dati dei pazienti. Il Professionista è il titolare del trattamento dei dati dei suoi pazienti, ed è lui a stabilire come e per quali finalità trattarli. Magellano S.C., proprietaria di PSICOGENIUS, agisce esclusivamente come “Responsabile del trattamento”, eseguendo solo le operazioni strettamente necessarie per l’erogazione del servizio e seguendo le istruzioni del Professionista, come previsto dal Regolamento GDPR (art. 28).',
        selected: false,
      },
      {
        question: 'Dove vengono conservati i dati?',
        answer:
          'I dati personali, compresi i dati sanitari, sono ospitati su Google Cloud Platform, che garantisce una crittografia avanzata sia “at rest” (quando sono archiviati) sia “in transit” (quando vengono trasferiti). Questo assicura che i dati siano sempre protetti e criptati. Anche nel caso di un eventuale – per quanto molto improbabile – attacco informatico, i dati risulterebbero comunque criptati e non in chiaro.',
        selected: false,
      },
      {
        question: 'Chi può accedere ai dati?',
        answer:
          'Solamente il Professionista e i soggetti da lui autorizzati possono accedere ai dati dei pazienti. PSICOGENIUS utilizza esclusivamente i dati del professionista necessari per garantire il funzionamento della piattaforma, nel rispetto delle normative sulla privacy.',
        selected: false,
      },
      {
        question: 'Ci sono backup o rischi di perdita dati?',
        answer: `Abbiamo implementato un sistema di backup automatico ogni 72 ore per garantire la sicurezza dei dati. Inoltre, nel caso di eventuali disservizi o problemi tecnici, i dati restano sempre protetti e disponibili per il ripristino (ma sempre criptati).

Siamo consapevoli dell’importanza della privacy in ambito sanitario e vogliamo rassicurarla che PSICOGENIUS è progettato per rispettare i più alti standard di protezione dei dati con sistemi informatici più rigorosi di quanto richiesto dalla normativa vigente. Restiamo a disposizione per qualsiasi ulteriore chiarimento.`,
        selected: false,
      },
    ],
    selected: false,
  },
  {
    category: 'Calendario',
    questions: [
      {
        question: 'Come aggiungo un nuovo appuntamento al calendario?',
        answer:
          'Per aggiungere un nuovo appuntamento, accedi alla sezione Calendario e utilizza l\'opzione "Programma nuovo appuntamento". Potrai inserire data, orario e dettagli relativi all\'appuntamento. È possibile inserire un appuntamento anche mentre crei un nuovo paziente o a partire dalla scheda di un paziente già esistente nella sezione Pazienti.',
        selected: false,
      },
      {
        question:
          'Posso aggiungere un appuntamento di un paziente ancora non creato?',
        answer:
          'No, per inserire un appuntamento devo aver già creato la scheda paziente nell’apposita sezione “Pazienti”',
        selected: false,
      },
      {
        question: 'Posso cancellare un appuntamento dal calendario?',
        answer:
          'Sì, puoi cancellare un appuntamento selezionandolo nel calendario e cliccando sull\'opzione "Elimina". Attenzione: se cancelli un appuntamento passato verranno eliminati tutti i dati ad esso associati (appunti, audio, sintesi, topic analysis)',
        selected: false,
      },
      {
        question:
          'Come funziona la sincronizzazione del calendario con Google?',
        answer:
          "Il software permette di sincronizzare il calendario con il tuo account Google. Una volta attivata la sincronizzazione, gli appuntamenti presenti nel tuo calendario Google verranno importati automaticamente e saranno visibili all'interno del software.",
        selected: false,
      },
      {
        question:
          'Posso sincronizzare il mio calendario Apple (iPhone/Mac) con Google Calendar?',
        answer:
          'Sì, puoi visualizzare e modificare gli eventi di Google Calendar direttamente nell’app Calendario di iPhone o Mac. Basta aggiungere il tuo account Google al dispositivo.',
        selected: false,
      },
      {
        question: 'Come aggiungo Google Calendar al mio dispositivo?',
        answer: `Segui questi passaggi:
• Vai in Impostazioni > Calendario > Account > Aggiungi account.
• Scegli Google e inserisci le credenziali del tuo account.
• Assicurati che l’opzione Calendari sia attivata.
• Apri l’app Calendario: vedrai gli eventi di Google Calendar.`,
        selected: false,
      },
    ],
    selected: false,
  },
  {
    category: 'Pazienti',
    questions: [
      {
        question: 'Cosa posso fare a partire dalla sezione Pazienti?',
        answer: `Dalla sezione Pazienti potrai:
• Visualizzare i pazienti esistenti e tutti i dati ad essi relativi;
• Creare nuovi pazienti con l’apposita icona “+”;
• Contattare rapidamente i tuoi pazienti ;
• Cambiare lo stato del paziente: eliminarlo o renderlo inattivo.`,
        selected: false,
      },
      {
        question: 'Come cancellare o rendere inattivo un paziente dall’elenco?',
        answer:
          'Per cancellare un paziente seleziona l’opzione “elimina paziente” dal menu con i tre puntini a destra del nome; per renderlo inattivo seleziona l’opzione “cambia in inattivo”',
        selected: false,
      },
      {
        question: 'Perché rendere un paziente inattivo?',
        answer:
          'Rendere un paziente inattivo ti permette di distinguere i pazienti che non sono più in carico senza dover eliminare la sua scheda e tutti i dati contenuti in questa.',
        selected: false,
      },
      {
        question: 'Dove posso inserire informazioni relative ai pazienti?',
        answer: `Puoi inserire informazioni anagrafiche e fiscali in pazienti>singolo paziente>anagrafica.
Puoi inserire informazioni cliniche (anamnesi, diagnosi, farmacoterapia) in pazienti>singolo paziente>dati paziente.`,
        selected: false,
      },

      {
        question: 'Posso modificare i dati di un paziente?',
        answer:
          'Sì, è possibile modificare i dati del paziente accedendo alla scheda anagrafica e aggiornando i campi desiderati, come contatti, indirizzo, o informazioni fiscali.',
        selected: false,
      },

      {
        question: 'Cos\'è la "Linea di vita" di un paziente?',
        answer:
          'La "Linea di vita" rappresenta graficamente gli eventi importanti riferiti dal paziente nel corso dei colloqui, ordinati per data. Inserisci manualmente data ed evento in una tabella dedicata e il sistema genererà automaticamente la linea temporale.',
        selected: false,
      },
    ],
    selected: false,
  },
  {
    category: 'Intelligenza Artificiale',
    questions: [
      {
        question: "Cosa posso fare con l'intelligenza artificiale?",
        answer: `Caricando il file audio del colloquio, potrai:
-trascrivere automaticamente la conversazione e generare una sintesi.
-ottenere una Wordcloud relativa ai temi emersi nel colloquio
-ottenere l’estrazione dei topic emersi nel colloquio (analisi semantica).
Caricando i file di più colloqui, potrai ottenere:
-sintesi generale – sinossi dell’intera psicoterapia
-scheda clinica dinamica – scheda che restituisce una visione generale della storia del paziente raccolta nel corso dei colloqui
-frequenza, distribuzione e pesi dei diversi temi emersi nell’intera terapia (topic analysis)`,
        selected: false,
      },
      {
        question: 'Come vengono elaborati i risultati dell’AI?',
        answer: `I risultati prodotti dall’AI (sintesi, analisi, ecc.) vengono generati a partire dalla trascrizione del colloquio. Grazie a un sistema avanzato di programmazione dell’AI generativa, è possibile ottenere sintesi di qualità anche in presenza di piccole imprecisioni nella trascrizione (es. confusione nei turni di parola).
I modelli vengono aggiornati e migliorati costantemente, quindi nel tempo noterai una qualità sempre maggiore nei risultati ottenuti.`,
        selected: false,
      },
      {
        question: 'Posso caricare un video?',
        answer: 'No, al momento sono supportati solo file audio.',
        selected: false,
      },
      {
        question: 'Quali formati sono supportati per l’audio?',
        answer:
          'I file supportati sono m4a e mp3. Al momento non è possibile caricare file video. Puoi però convertire il tuo video in un audio attraverso gli strumenti di conversione a disposizione sul tuo dispositivo elettronico o sul web.',
        selected: false,
      },
      {
        question: 'Come funziona la trascrizione automatica dei colloqui?',
        answer:
          'Dopo aver caricato la registrazione, l’AI trascrive la conversazione differenziando i turni conversazionali tra paziente e terapeuta. Questo consente una separazione delle parti coinvolte nel dialogo.',
        selected: false,
      },
      {
        question: 'Dove trovo la trascrizione del colloquio?',
        answer:
          'Puoi scaricare la trascrizione del colloquio attraverso il pulsante dei tre puntini, collocato sulla riga del colloquio di interesse a destra.',
        selected: false,
      },
      {
        question:
          'Dove vengono salvati l’audio e la trascrizione del colloquio?',
        answer: `L’audio e la trascrizione non vengono salvati all’interno del software. Una volta caricata la registrazione, viene avviata automaticamente la trascrizione, che sarà disponibile per il download.
Per motivi di sicurezza, la trascrizione non viene archiviata nel sistema.
Tutti i materiali – inclusi gli output generati dall’AI – rimangono di proprietà esclusiva del Professionista e sono crittografati per garantire la massima protezione, sia da accessi esterni sia da parte degli operatori del software.`,
        selected: false,
      },
      {
        question: 'Cosa include la sintesi automatica generata dall’AI?',
        answer:
          "La sintesi del colloquio riassume i punti principali trattati e fornisce, nell'ultimo paragrafo, un consiglio su quali tematiche approfondire nel prossimo incontro, basandosi su quanto emerso nella conversazione.",
        selected: false,
      },
      {
        question:
          'Cosa posso fare se la sintesi del colloquio non mi soddisfa?',
        answer: `Se ritieni che la sintesi sia incompleta o manchi di dettagli rilevanti, puoi modificarla manualmente cliccando sull’icona a forma di penna. Ricordati di salvare le modifiche effettuate attraverso lo stesso pulsante.

Rivedere la sintesi in tempo reale aiuta il sistema a personalizzarsi e migliorare nel tempo, modellandosi sul tuo modo di selezionare e valorizzare le informazioni di un colloquio.`,
        selected: false,
      },
      {
        question:
          'Se carico più colloqui dello stesso paziente, l’AI tiene conto del contesto precedente?',
        answer:
          'Sì. Ogni volta che viene caricato un nuovo colloquio, il sistema è progettato per ricostruire il contesto a partire dalle trascrizioni e analisi precedenti, così da offrire una comprensione coerente e continua del percorso del paziente.',
        selected: false,
      },
      {
        question: 'Cosa sono le Wordcloud e come vengono create?',
        answer:
          'Le Wordcloud sono rappresentazioni grafiche delle parole chiave più frequenti emerse durante il colloquio. Ad esempio, se un paziente ha parlato della maratona di Madrid, la word cloud potrebbe includere parole come “maratona”, “settembre”, “Madrid”, ecc.',
        selected: false,
      },
      {
        question: "Cos'è l'estrazione dei Topic?",
        answer: `L'AI identifica i principali temi (topic) trattati durante il colloquio, come ad esempio "relazioni affettive", "sofferenza", o "famiglia".
Ogni topic viene visualizzato in un grafico con una percentuale, che indica quanto è stato trattato rispetto agli altri temi nel corso della conversazione.
Puoi anche visualizzare l’andamento dei topic nel tempo, sulla base di distribuzione, frequenza e pesi di questi ultimi nel corso dell’intera psicoterapia. Anche questo viene visualizzato attraverso un grafico in cui puoi selezionare i temi di cui ti interessa osservare l’andamento; puoi decidere quali topic visualizzare per comprendere come sono cambiati nel corso della terapia. I temi selezionati appariranno colorati, quelli non selezionati in grigio.`,
        selected: false,
      },
      {
        question: "Cos'è la sintesi complessiva e come viene utilizzata?",
        answer:
          'La sintesi complessiva è un riassunto che raccoglie le informazioni emerse da tutti i colloqui caricati fino a quel momento. Fornisce una panoramica dell’evoluzione della terapia e dei principali argomenti trattati.',
        selected: false,
      },
    ],
    selected: false,
  },
  {
    category: 'Documenti',
    questions: [
      {
        question: 'Quali documenti sono inclusi in questa sezione?',
        answer:
          'In questa sezione troverai e potrai inserire documenti generici, che non siano relativi ad un singolo paziente. Puoi inserire e trovare i documenti del singolo paziente in pazienti>singolo paziente>documenti paziente.',
        selected: false,
      },
      {
        question: 'Quali tipi di file sono supportati nella sezione Documenti?',
        answer:
          'Nella sezione Moduli puoi caricare documenti nei seguenti formati: Word (.doc, .docx), PDF, immagini (.jpeg) e presentazioni PowerPoint (.ppt, .pptx).',
        selected: false,
      },
      {
        question: 'Posso organizzare i documenti in categorie specifiche?',
        answer:
          'Si, dopo aver caricato un documento, puoi assegnargli una categoria (es. "Burocrazia", "Didattica", "Documenti personali") utilizzando i filtri disponibili. Questo ti aiuta a tenere organizzati i file in base al loro utilizzo.',
        selected: false,
      },
      {
        question: "E' possibile modificare un documento caricato?",
        answer:
          'No, i documenti caricati non possono essere modificati direttamente nel software. Tuttavia, puoi cancellare un documento e ricaricare una versione aggiornata se necessario.',
        selected: false,
      },
      {
        question:
          'Come posso visualizzare o scaricare i documenti già caricati?',
        answer:
          "Nella sezione Documenti, puoi selezionare un documento dall'elenco per visualizzarlo o scaricarlo sul tuo dispositivo. Clicca sul documento desiderato per accedere a queste opzioni.",
        selected: false,
      },
      {
        question: 'Posso cancellare un documento una volta caricato?',
        answer:
          'Sì, puoi cancellare un documento selezionandolo dall\'elenco e utilizzando l\'opzione "Elimina". Il documento verrà rimosso dal sistema.',
        selected: false,
      },
      {
        question: 'Posso condividere i documenti caricati con altri utenti?',
        answer:
          "Attualmente, la condivisione diretta dei documenti con altri utenti non è una funzione disponibile nel software. I documenti possono essere visualizzati solo dall'utente che li ha caricati.",
        selected: false,
      },
      {
        question: "C'è un limite al numero di documenti che posso caricare?",
        answer:
          'Non è stato indicato un limite specifico al numero di documenti che puoi caricare, ma ti consigliamo di gestire i file con criterio per mantenere organizzata la sezione Moduli.',
        selected: false,
      },
    ],
    selected: false,
  },
  {
    category: 'Fatturazione',
    questions: [
      {
        question: "Il software supporta l'invio automatico delle fatture?",
        answer:
          'Sì, il software ti permette di inviare le fatture generate sia al sistema di interscambio che al sistema tessera sanitaria.',
        selected: false,
      },
      {
        question: 'Come si crea una fattura ad un cliente privato o azienda?',
        answer: `Per creare una fattura ad un cliente, privato o azienda, è necessario seguire questi passaggi:
1)  inserire al primo accesso i propri dati di fatturazione attraverso la sotto-sezione “i miei dati”.
2)  creare il cliente attraverso la sotto-sezione “elenco clienti”; è possibile associare il cliente alla relativa scheda paziente flaggando l’apposito pulsante in alto alla schermata.
3)  a partire dalla sezione “fatture” cliccare sul pulsante “+” in alto a destra. “+sts” indica fatture a privati, “+sdi” indica fatture elettroniche.
4)  compilare tutti i campi e in fondo al form selezionare “salva bozza” se si intende modificare la fattura in un secondo momento o “salva pronta” se si intende inviare.
Una volta compilati tutti i campi della fattura, questa potrà essere salvata come bozza o come pronta da inviare.`,
        selected: false,
      },
      {
        question: 'Come si crea un cliente?',
        answer: `Per creare un cliente è necessario accedere alla sotto-sezione “elenco clienti”, divisa in clienti privati e aziende. Attraverso il pulsante “+” è possibile aggiungere un nuovo paziente-cliente, associandolo alla relativa scheda paziente già esistente mediante il flag dell’apposito pulsante in alto alla schermata.`,
        selected: false,
      },
      {
        question:
          'E’ possibile emettere una fattura verso un cliente che non è un paziente?',
        answer: `Sì, per farlo è sufficiente creare un cliente, privato o azienda, attraverso la sotto-sezione “elenco clienti” e non associarlo ad una scheda paziente, inserendo manualmente tutti i suoi dati.`,
        selected: false,
      },
      {
        question: 'Come vengono visualizzate le fatture create?',
        answer: `Le fatture create vengono visualizzate in una tabella di riepilogo alla sottosezione Fatture inviate.
Qui puoi visualizzare tutte le fatture: fatture destinate a privati contraddistinte da un numero (001) e fatture destinate ad aziende contraddistinte da un numero e una siglia (001(SDI).
La colonna “stato” indica se la fattura è salvata come bozza/pronta da inviare/se è stata inviata (rispettivamente a STS o a SDI).
Attraverso gli appositi filtri posti in alto alla schermata è possibile limitare la visualizzazione alle categorie di interesse.`,
        selected: false,
      },
      {
        question: 'Come si modifica una fattura?',
        answer: `E’ possibile modificare una fattura finchè questa si trova nello stato “bozze”.
E’ possibile modificare una fattura a partire dalla tabella di riepilogo alla sezione “fatture”, cliccando sui tre puntini a destra dell’elenco e selezionare “modifica”.
Una volta salvata come “pronta da inviare” non sarà più possibile apportare modifiche.`,
        selected: false,
      },
      {
        question: 'E’ possibile eliminare una fattura?',
        answer: `E’ possibile eliminare una fattura finchè questa si trova nello stato di bozza.
E’ possibile eliminare una fattura a partire dalla tabella di riepilogo, cliccando sui tre puntini a destra e selezionando “elimina”`,
        selected: false,
      },
      {
        question: 'Come cambio lo stato di una fattura da “bozza” a “pronta”?',
        answer: `Per contrassegnare una fattura come pronta da inviare vai nella tabella di riepilogo, clicca sui tre puntini a destra, seleziona modifica, scorri la fattura fino in fondo e seleziona “salva pronta”.
Se sai di non dover apportare modifiche, puoi salvare la fattura come pronta da inviare anche in fase di creazione.`,
        selected: false,
      },
      {
        question: 'Come invio la fattura al mio cliente?',
        answer: `E’ possibile inviare una fattura al proprio cliente quando questa è stata salvata come pronta da inviare. Per farlo clicca sui tre puntini a destra e seleziona “invia email al cliente”.`,
        selected: false,
      },

      {
        question: 'Come invio una o più fatture al Sistema Tessera Sanitaria?',
        answer: `Dopo aver contrassegnato le fatture di interesse come pronte da inviare, selezionale dall’elenco della tabella di riepilogo e clicca sul pulsante “invia a STS” che compare in alto alla schermata.
Per poter inviare una fattura è necessario che questa venga contrassegnata come “pagata” ed inserire la relativa data di pagamento.`,
        selected: false,
      },
      {
        question: 'Dove trovo username, password e PIN STS?',
        answer: `Username sts e password sts sono le credenziali di accesso all’area riservata del sito sistema tessera sanitaria (https://sistemats1.sanita.finanze.it/portale/home.) Se non sei ancora registrato, dovrai farlo per poter inviare le tue fatture al sistema.
Una volta effettuato il login troverai il tuo pincode accedendo alla sezione profilo utente e quindi cliccando stampa pin code (tutorial: https://www.iatros.it/download/acn/Ottenere-il-PINCODE-da-sistemats.pdf)`,
        selected: false,
      },
      {
        question:
          'Come invio una fattura elettronica al Sistema di Interscambio?',
        answer: `Dopo aver contrassegnato la fattura come “pronta da inviare”, selezionala dall’elenco della tabella di riepilogo ssibile selezionare le fatture che si desiderano inviare dalla tabella di riepilogo alla sezione Fatture e selezionare il pulsante “invia” che compare in alto alla schermata.`,
        selected: false,
      },
      {
        question: 'Posso scaricare la fattura creata?',
        answer: `Sì, puoi scaricare la fattura creata una volta contrassegnata come “pronta”. Seleziona “scarica PDF” dal menu dei tre puntini. Adestra.`,
        selected: false,
      },
      {
        question:
          'Se un paziente viene eliminato dalla lista pazienti vengono eliminate anche le fatture emesse nei suoi confronti?',
        answer: `No, le fatture associate vengono conservate nella sezione Fatture.`,
        selected: false,
      },
      {
        question: 'Come funziona la numerazione delle fatture?',
        answer: `La numerazione delle fatture è automatica e progressiva, partendo dal numero 001.
Se hai già emesso delle fatture nell’anno in corso, dovrai impostare manualmente il numero della prima fattura creata con psicogenius.`,
        selected: false,
      },
      {
        question: "Ci sono costi aggiuntivi per l'invio delle fatture?",
        answer: `No, tutte le funzionalità di invio delle fatture sono incluse nel costo del software, senza spese nascoste.`,
        selected: false,
      },
      {
        question: 'Come vengono contrassegnate le fatture già inviate?',
        answer: `Per le fatture già inviate comparirà la dicitura “inviata” nella colonna “stato”.`,
        selected: false,
      },
      {
        question:
          'Se sbaglio ad emettere una fattura, è possibile emettere una nota di credito?',
        answer: `Sì, clicca su “+SDI” e alla voce “tipo” seleziona “note di credito SDI”.`,
        selected: false,
      },
      {
        question:
          'E’ possibile visualizzare anche le fatture elettroniche ricevute tramite SdI?',
        answer: `Sì, per farlo è però necessario registrare sul sito dell'agenzia delle entrate il Codice Destinatario di Acube, servizio di fatturazione adoperato dal software.`,
        selected: false,
      },
      {
        question:
          'Come registro il codice destinatario di Acube sul sito dell’agenzia delle entrate?',
        answer: `Collegati al link  https://ivaservizi.agenziaentrate.gov.it/portale/  ed esegui l’autenticazione con SPID, CNS o Codice Fiscale / Codice Entratel, quindi:
        1. Scegli la sezione “Fatture e Corrispettivi”;
        2. Seleziona tra i “Servizi Disponibili – Fatturazione Elettronica” la voce “Registrazione dell’indirizzo telematico dove ricevere tutte le fatture elettroniche”;
        3. Inserisci il Codice destinatario Acube JKKZDGR
        4. Conferma l’operazione.`,
        selected: false,
      },
    ],
    selected: false,
  },
];
